import React, { FC } from 'react'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import {
  RequestForProposal,
  ShipperApplication,
} from 'apps/marketplace/apiTypes/requestForProposals'
import { Table, TableHead, TableBody, TableCell, TableRow } from 'transfix-ui'
import { RequestForProposalsTableRow } from './RequestForProposalsTableRow'

enum TABLE_COLUMNS {
  id = 'ID',
  createdAt = 'Created At',
  rfpType = 'RFP Type',
  salesforceRfpTitle = 'Salesforce RFP Title',
  shipper = 'Shipper',
  googleSheetsUrl = 'Google Sheets URL',
  salesforceRfpId = 'Salesforce RFP ID',
  status = 'Status',
  creator = 'Creator',
  actions = '',
}

interface IRequestForProposalsTableProps {
  requestForProposals: RequestForProposal[]
  openDeleteConfirmation: (id: number) => void
  openEditConfirmation: (
    id: number,
    salesforceRfpId: string,
    rfpType: string,
    shipperApplication: ShipperApplication
  ) => void
}

export const RequestForProposalsTable: FC<IRequestForProposalsTableProps> = ({
  requestForProposals = [],
  openDeleteConfirmation,
  openEditConfirmation,
}) => {
  if (requestForProposals.length === 0) {
    return (
      <Box my={2} textAlign='center'>
        <Typography variant='h3'>No RFPs Found</Typography>
      </Box>
    )
  }

  return (
    <Table>
      <TableHead>
        <TableRow tableCellType='th'>
          {Object.entries(TABLE_COLUMNS).map(([key, value]) => (
            <TableCell
              tableCellType='th'
              key={`${key}-column-header`}
              dataTest={`${key}-column-header`}>
              {value}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody dataTest='request-for-proposals-table'>
        {requestForProposals.map(rfp => (
          <RequestForProposalsTableRow
            key={rfp.id}
            requestForProposal={rfp}
            openDeleteConfirmation={openDeleteConfirmation}
            openEditConfirmation={openEditConfirmation}
          />
        ))}
      </TableBody>
    </Table>
  )
}
